export const actionColumns = ['actions'];
export const pageSizes = [10, 20, 50];
export const filteringStateColumnExtensions = [
  { columnName: 'actions', filteringEnabled: false },
];

export const drawerWidth = 260;
export const drawerClosedWidth = 50;
export const addEditDrawerWidth  = 550;